import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

import FormFieldLabel from './FormFieldLabel';
import InputContainer from './InputContainer';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  margin-bottom: 16px;

  ${FormFieldLabel} {
    flex: 0.25;
    text-align: left;
    padding-right: 0.75em;

    ${media.moreThan('md')`
      text-align: right;
    `};
  }

  ${InputContainer} {
    flex: 1;
  }
`;
